import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

import { MeService } from '../../services/me.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private readonly meService: MeService,
    private readonly msalService: MsalService,
    private readonly router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    if (!this.meService.isAuthenticated()) {
      return this.router.createUrlTree(['/login']);
    }

    const activeAccount = this.msalService.instance.getActiveAccount();
    if (activeAccount) {
      return true;
    }

    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      this.msalService.instance.setActiveAccount(accounts[0]);
      return true;
    }

    return this.router.createUrlTree(['/login']);
  }
}
